"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateRegisteredCurrencyVault = exports.updateRegisteredCurrencyRoyalty = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const state_1 = require("../state");
/**
 * Used to update the royalty rate for a registered currency
 * @param program - GalacticMarketplace Program
 * @param updateAuthorityAccount - the authority of the market
 * @param currencyMint - Registered currency's mint
 * @param royalty - Royalty rate for exchanges denominated in this currency (Royalty of '1_000_000' == 100%)
 * @returns InstructionReturn
 */
function updateRegisteredCurrencyRoyalty(program, updateAuthorityAccount, currencyMint, royalty) {
    return () => __awaiter(this, void 0, void 0, function* () {
        return ({
            instruction: yield program.methods
                .updateCurrencyRoyalty(new anchor_1.BN(royalty))
                .accountsStrict({
                updateAuthorityAccount: updateAuthorityAccount.publicKey(),
                marketVarsAccount: state_1.MarketVars.findAddress(program)[0],
                registeredCurrency: state_1.RegisteredCurrency.findAddress(program, currencyMint)[0],
                currencyMint,
                systemProgram: web3_js_1.SystemProgram.programId,
            })
                .instruction(),
            signers: [updateAuthorityAccount],
        });
    });
}
exports.updateRegisteredCurrencyRoyalty = updateRegisteredCurrencyRoyalty;
/**
 * Updates the Currency Vault associated with a RegisteredCurrency
 * @param program - GalacticMarketplace Program
 * @param updateAuthorityAccount - the authority of the market
 * @param currencyMint - Registered currency's mint
 * @param saCurrencyVault - Token account to which royalties for this currency are to be sent
 * @returns InstructionReturn
 */
function updateRegisteredCurrencyVault(program, updateAuthorityAccount, currencyMint, saCurrencyVault) {
    return () => __awaiter(this, void 0, void 0, function* () {
        return ({
            instruction: yield program.methods
                .updateCurrencyVault()
                .accountsStrict({
                updateAuthorityAccount: updateAuthorityAccount.publicKey(),
                marketVarsAccount: state_1.MarketVars.findAddress(program)[0],
                registeredCurrency: state_1.RegisteredCurrency.findAddress(program, currencyMint)[0],
                currencyMint,
                systemProgram: web3_js_1.SystemProgram.programId,
                saCurrencyVault,
            })
                .instruction(),
            signers: [updateAuthorityAccount],
        });
    });
}
exports.updateRegisteredCurrencyVault = updateRegisteredCurrencyVault;
//# sourceMappingURL=updateCurrency.js.map